import type { ElementType, ReactNode } from "react";
import styles from "./Container.module.css";

/** The one page gutter. Mobile-first: 16px, widening to 32px from 768px. */
export function Container({
  as: Tag = "div",
  className,
  children,
}: {
  as?: ElementType | undefined;
  className?: string | undefined;
  children: ReactNode;
}) {
  return <Tag className={[styles.container, className].filter(Boolean).join(" ")}>{children}</Tag>;
}
